import { vec2 } from "@tlaukkan/tsm";
import { CameraZoomLevel, PhysicsConstants, Resolution } from "../../../shared/constants";
import { CameraSystem } from "../systems/cameraSystem";
import { SoundEffect } from "./soundEffect";
import { DistanceVolumeReductionFactor } from "./volumes";
import { SoundEngine } from "./soundEngine";

export class SpatializedSoundEffect extends SoundEffect {
	panner: PannerNode;

	constructor(engine: SoundEngine, private camera: CameraSystem, files: Array<string>, protected output: AudioNode) {
		super(engine, files, output);
		this.context = this.engine.audioContext;

		const panner = this.context.createPanner();
		this.panner = panner;

		panner.panningModel = 'HRTF';
		panner.distanceModel = 'inverse';
		panner.refDistance = 1;
		panner.maxDistance = PhysicsConstants.Width;
		panner.rolloffFactor = 0.1;
		panner.coneInnerAngle = 360;
		panner.coneOuterAngle = 0;
		panner.coneOuterGain = 0;
		panner.orientationX.setValueAtTime(1, this.context.currentTime);
		panner.orientationY.setValueAtTime(0, this.context.currentTime);
		panner.orientationZ.setValueAtTime(0, this.context.currentTime);
	}

	async init() {
		super.init();
		this.panner.connect(this.output);
	}

	playDiegetic(screenPosition: vec2, zoomLevel: CameraZoomLevel, pitchRandomization = true) {
		if (!this.tracks) return;
		const ctx = this.engine.audioContext;
		const normalizedScreenPosX = 2 * (screenPosition.x / Resolution.Width) - 1
		const normalizedScreenPosY = 2 * (screenPosition.y / Resolution.Height) - 1;
		this.panner.positionX.setValueAtTime(normalizedScreenPosX, ctx.currentTime);
		this.panner.positionY.setValueAtTime(normalizedScreenPosY, ctx.currentTime);
		const z = zoomLevel * -DistanceVolumeReductionFactor;
		this.panner.positionZ.setValueAtTime(z, ctx.currentTime);

		const source = this.context.createBufferSource();
		const random = Math.floor(Math.random() * this.tracks.length);
		source.buffer = this.tracks[random];
		source.connect(this.gain);
		if (pitchRandomization) {
			this.gain.connect(this.panner);
			const pitchVariation = 0.9 + (Math.random() * 0.2);
			source.playbackRate.value = pitchVariation;
		}
		else {
			this.gain.connect(this.output);
		}
		source.start();
	}
}
